<template>
  <a-layout class='s_bf' style="background-color:#f5f5f5">
      <!-- <a-form ref='form' :model='search' :style="{'marginBottom':'15px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='keyword'>
          <a-input v-model:value="search.keyword" style="width:250px" placeholder="活动ID、活动主题" />
        </a-form-item>
        <a-form-item label="流水号" name='serial_sn'>
          <a-input v-model:value="search.serial_sn" style="width:250px" placeholder="请输入流水号" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form> -->
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='code' :columns='columns' :data-source='data' :row-selection="{ selectedRowKeys: selectedRowKeys,getCheckboxProps: getCheckboxProps, onChange: onSelectChange }">
          <template v-slot:status="{ record }">
            {{record.status == 1 ? '未开始':'进行中'}}
          </template>
          <template v-slot:activity_name="{ record }">
            {{record.activity_name}}
            <p class="s_c999">ID:{{record.activity_id}}</p>
          </template>
        </a-table>
        <!-- <a-pagination :style="{marginTop:'15px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
  </a-layout>
</template> 
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import { activitysRangesList } from "@/api/qrcode";
const def = {
  page: 1,
  limit: 10,
  keyword: "",
  batch_sn:'',
  serial_sn:''
};
export default {
  props: {
    batch_sn: String,
    activitysList: Array,
    activity_id:Number || String
  },
  name: "selectActivitys",
  components: { },
  setup(props, { emit }) {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      selectedRowKeys:[]
    });
    let data = ref([]);

    let columns = [
      // {
      //   title: "活动主题",
      //   dataIndex: "activity_name",
      //   key: "activity_name",
      //   slots: { customRender: "activity_name" }
      // },
      {
        title: "流水号范围",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "区间数量",
        dataIndex: "small_code_counts",
        key: "small_code_counts"
      },
      // {
      //   title: "活动状态",
      //   dataIndex: "status",
      //   key: "status",
      //   slots: { customRender: "status" }
      // },
      // {
      //   title: "启用时间",
      //   dataIndex: "created_time",
      //   key: "created_time",
      // },
    ];
    const onSelectChange = (selectedRowKeys) => {
      console.log(selectedRowKeys)
      state.selectedRowKeys = selectedRowKeys;
      emit("select", selectedRowKeys);
    };
    // const getCheckboxProps =  (record) => ({
    //   disabled: !record.range.length,
    // });
    const initData = async (values) => {
      state.listLoading = true;
      let res = await activitysRangesList(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        // state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref(def);
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      search.value.batch_sn = props.batch_sn
      search.value.activity_id = props.activity_id
      state.selectedRowKeys = props.activitysList
      initData(search.value);
    });
    const $router = inject("$router");

    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onSelectChange,
      // getCheckboxProps
    };
  },
};
</script>